import { inject, Injectable, signal } from '@angular/core';
import {
  ApiService,
  ESearchBlockPath,
  ISearchBlockOptions,
} from '@web-nx-ng-tsc/web-shared-data-access';
import { tap } from 'rxjs';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({
  providedIn: 'root',
})
export class LibSearchBlockService {
  private readonly apiService = inject(ApiService);
  private readonly loggingService = inject(LoggingService);

  private widthListSignal = signal<any>(undefined);
  private heightListSignal = signal<any>(undefined);
  private sizeListSignal = signal<any>(undefined);
  private typeListSignal = signal<any>(undefined);
  private brandListSignal = signal<any>(undefined);
  private modelListSignal = signal<any>(undefined);

  // NOTE: GET SIGNAL //
  getWidthListSignal() {
    return this.widthListSignal;
  }
  getHeightListSignal() {
    return this.heightListSignal;
  }
  getSizeListSignal() {
    return this.sizeListSignal;
  }
  getTypeListSignal() {
    return this.typeListSignal;
  }
  getBrandListSignal() {
    return this.brandListSignal;
  }
  getModelListSignal() {
    return this.modelListSignal;
  }

  // ---------------- //
  // NOTE: CLEAR SIGNAL //
  clearWidthListSignal() {
    this.widthListSignal.set(undefined);
  }
  clearHeightListSignal() {
    this.heightListSignal.set(undefined);
  }
  clearSizeListSignal() {
    this.sizeListSignal.set(undefined);
  }
  clearTypeListSignal() {
    this.typeListSignal.set(undefined);
  }
  clearBrandListSignal() {
    this.brandListSignal.set(undefined);
  }
  clearModelListSignal() {
    this.modelListSignal.set(undefined);
  }
  // ---------------- //

  getDataSearchBlock(category: string, path: ESearchBlockPath, visibility: string, options: ISearchBlockOptions = {}) {
    this.loggingService.log('getDataSearchBlock', category);
    this.loggingService.log('getDataSearchBlock', path);
    this.loggingService.log('getDataSearchBlock', visibility);
    this.loggingService.log('getDataSearchBlock', options);
    return this.apiService.getDataSearchBlock(category, path, visibility, options).pipe(
      tap((res) => this.loggingService.warn('[GET] getDataSearchBlock :: =>', res)),
      tap((res) => this.conditionCheckDataSearch(path, res))
    );
  }

  conditionCheckDataSearch(path: ESearchBlockPath, item: any) {
    this.loggingService.log('path', path);
    this.loggingService.log('item', item);
    switch (path) {
      case ESearchBlockPath.WIDTH:
        this.loggingService.log('set signal width');
        this.widthListSignal.set(item);
        break;
      case ESearchBlockPath.HEIGHT:
        this.loggingService.log('set signal height');
        this.heightListSignal.set(item);
        break;
      case ESearchBlockPath.SIZE:
        this.loggingService.log('set signal size');
        this.sizeListSignal.set(item);
        break;
      case ESearchBlockPath.TYPE:
      case ESearchBlockPath.TYPE_NT:
        this.loggingService.log('set signal type');
        this.typeListSignal.set(item);
        break;
      case ESearchBlockPath.BRAND:
      case ESearchBlockPath.BRAND_NT:
        this.loggingService.log('set signal brand');
        this.brandListSignal.set(item);
        break;
      case ESearchBlockPath.MODEL:
      case ESearchBlockPath.MODEL_NT:
        this.loggingService.log('set signal model');
        this.modelListSignal.set(item);
        break;

      default:
        this.loggingService.log('default');
        break;
    }
  }
}
